// removed by extract-text-webpack-plugin
module.exports = {"name-flex":"name-flex___2aXGF center___2iqBf","name":"name___1LBkC h1___3_4RF","name-label-logo":"name-label-logo___3DGHk","name-logo":"name-logo___1hYZx","name-label":"name-label___3rZrK","leaf":"leaf___3sIhd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesNameHeader/TargetDateSeriesNameHeader.css
// module id = 933
// module chunks = 0